import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as vfs from 'pdfmake/build/vfs_fonts.js';

pdfMake.vfs = vfs;

export default pdfMake;